import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-input-form',
    templateUrl: './input-form.component.html',
    styleUrls: ['./input-form.component.scss'],
    standalone: false
})
export class InputFormComponent implements OnInit {
  @Input() label: string;
  @Input() icon: string;
  @Input() note: string;
  @Input() error = false;

  constructor() {}

  ngOnInit() {}
}
